// TODO: change this component to not expect the session properties directly but inside an object

import React from 'react';

import {isExternalContentAvailable} from '../../../../data/filters/scheduleFilters';
import {useUpdateWhenScheduleAdvances} from '../../../../data/hooks/datetimeHooks';
import { useMeeting } from '../../../../data/hooks/meeting/useMeeting';
import { useProgramSession } from '../../../../data/hooks/schedule/useProgramSession';
import {openExternalURL} from '../../../../misc/openLinks';
import CollectClick from '../../../collect/CollectClick';
import ExternalContentIcon from '../../icons/ExternalContentIcon/ExternalContentIcon';
import Link from '../../Link';
import styles from './ExternalLinkButton.module.scss';

// Handles a button click a little different for virtual room.
const ExternalLinkButton = props => {
    const {
            className = '',
            session_content_url,
            session_content_button_label,
            onClick,
            eventId,
            style,
            session_content_url_target = 'iframe',
            session_content_type,
            session_content_display_time,
            start_utc,
            programId,
            meetingId,
        } = props,
        disabled = props.disabled || (start_utc && !isExternalContentAvailable({start_utc, session_content_display_time})),
        targetIframe = session_content_url_target === 'iframe',
        program = useProgramSession(eventId, programId),
        meeting = useMeeting(eventId, meetingId),
        url = meeting?.virtualroom_url || program?.session_content_url;

    useUpdateWhenScheduleAdvances(eventId);

    const handleLinkClicked = e => {
        if (!disabled) {
            openExternalURL({url, target: session_content_url_target, eventId, programId, meetingId});
            if (onClick) {
                onClick(e);
            }
        }
    };

    if (!session_content_url) return null;

    // NOTE: disabled isn't a valid attribute of <A>

    return (
        <CollectClick objectType="program.session_content_url" objectId={programId} objectDetail={session_content_url}>
            <Link
                className={['ExternalLinkButton', styles.ExternalLinkButton, className, disabled ? 'disabled' : ''].join(' ')}
                href={disabled || session_content_url_target === 'iframe' ? undefined : session_content_url}
                disabled={disabled}
                style={style}
                title={session_content_button_label}
                onClick={handleLinkClicked}>
                <div className="text-center" style={{color: 'white'}}>
                    {session_content_url_target && (
                        <ExternalContentIcon session_content_type={session_content_type} style={{marginRight: 6}} disabled={disabled} />
                    )}
                    {session_content_button_label}
                </div>
            </Link>
        </CollectClick>
    );
};

export default ExternalLinkButton;
